import { Zap } from "lucide-react";
import { MARQUEE_ITEMS } from "@/data/site";

const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="bg-ink border-y border-steel overflow-hidden py-5" data-testid="accreditation-marquee" aria-hidden="true">
      <div className="marquee-track">
        {items.map((item, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="font-mono text-sm uppercase tracking-[0.3em] text-white/70 px-8">
              {item}
            </span>
            <Zap className="w-4 h-4 text-volt-bright shrink-0" fill="currentColor" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
